import axios from "@/axios";

export const getCurrentUsername = async (): Promise<string> => {
    const response = await axios.get("/api/user");
    if (typeof response.data === "string") return response.data;
    return "";
}